// extracted by mini-css-extract-plugin
module.exports = {"cancelButtonPopUp":"LeavePagePopup_cancelButtonPopUp__3Y0Px"};